import NamespacedSerializer from '@linc-technologies/linced-common/serializers/namespaced';

// Base maps `people/x` model names to the `x` payload keys of the people
// service. `people` and `person` name the person model.
export default class Base extends NamespacedSerializer {
  namespace = 'people';
  rootKeys = ['people', 'person'];
}
